import { colors, Icon, iconSizes, mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const ReloadIcon = styled(Icon).attrs({ code: "refresh", size: iconSizes._20 })<{ isSpinning: boolean }>`
  color: ${colors.textLighter};
  padding: 0.5rem;
  ${({ isSpinning }) => isSpinning && mixin.spin};

  :hover {
    color: ${colors.textDark};
    ${mixin.clickable};
  }
`
